module.exports = __webpack_public_path__ + "img/internet.0cc537e6.svg";